var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"tabs h-80"},_vm._l((_vm.options),function(item){return _c('div',{key:item.key,staticClass:"tab",class:{ active: item.key === _vm.curTab },on:{"click":() => _vm.handleTabClick(item.key)}},[_c('div',{staticClass:"tab-text"},[_vm._v(_vm._s(item.text))])])}),0),_c('div',{staticClass:"h-80"})])
}
var staticRenderFns = []

export { render, staticRenderFns }